import { render, staticRenderFns } from "./OtherContributionForm.vue?vue&type=template&id=b27ea4ac&scoped=true"
import script from "./OtherContributionForm.vue?vue&type=script&lang=ts"
export * from "./OtherContributionForm.vue?vue&type=script&lang=ts"
import style0 from "./OtherContributionForm.vue?vue&type=style&index=0&id=b27ea4ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27ea4ac",
  null
  
)

export default component.exports